// Coach Configuration
export const COACH_CONFIG = {
  coachUserId: 'eq6aJ44JEUa5Xp75YZnol6CQgfJ3',
  coachName: 'Coach HT',
  gymName: 'THE PHYT GYM',
  apiBaseUrl: 'https://kinos-api.onrender.com/api',
  workspaceId: 'aOnGJHBcfjh2BHmhxyfO'
};

// You can add more coach-specific configuration here
export const COACH_DETAILS = {
  name: 'Heather (HT)',
  email: 'phytgymla@gmail.com',
  location: 'Los Angeles, CA',
  specialties: ['Fat Loss', 'Form & Alignment', 'PHYT Method', 'Nutrition Coaching'],
  experience: '8+ years',
  clientsTrained: '500+',
  successRate: '95%'
}; 


//test

// export const COACH_CONFIG = {
//   coachUserId: '0XsVJ0zyZ0TgpKkeLIWzJ2FBuq93',
//   coachName: 'CoachDavies Odu',
//   gymName: 'Davies Odu Gym',
//   apiBaseUrl: 'http://localhost:3001/api',
//   // apiBaseUrl: 'https://kinos-api.onrender.com/api',
//   workspaceId: 'q6jCernePI9B94NRXu1f'
// };

// // You can add more coach-specific configuration here
// export const COACH_DETAILS = {
//   name: 'Davies Odu',
//   email: 'daviesodu@gmail.com',
//   location: 'Los Angeles, CA',
//   specialties: ['Fat Loss', 'Form & Alignment', 'PHYT Method', 'Nutrition Coaching'],
//   experience: '8+ years',
//   clientsTrained: '500+',
//   successRate: '95%'
// }; 